import chroma from 'chroma-js';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  selectFieldBackgroundColor,
  selectFieldTextColor,
  selectFormColor,
  selectFormImageUrl,
} from '../../../store/reducers/forms';

const ALPHA_THRESHOLD = 0.5;
const CONTRAST_THRESHOLD = 2.5;

const calculateEffectiveBg = (inputBgChroma, formBgChroma) => {
  const inputAlpha = inputBgChroma.alpha();

  if (!formBgChroma || inputAlpha >= 1) return inputBgChroma;
  if (inputAlpha <= 0) return formBgChroma;

  const inputRgb = inputBgChroma.rgb();
  const formRgb = formBgChroma.rgb();

  const effectiveR = inputRgb[0] * inputAlpha + formRgb[0] * (1 - inputAlpha);
  const effectiveG = inputRgb[1] * inputAlpha + formRgb[1] * (1 - inputAlpha);
  const effectiveB = inputRgb[2] * inputAlpha + formRgb[2] * (1 - inputAlpha);

  return chroma(effectiveR, effectiveG, effectiveB);
};

export function useInputAlert() {
  const [alert, setAlert] = useState(false);
  const formBackgroundColor = useSelector(selectFormColor);
  const formBackgroundImage = useSelector(selectFormImageUrl);
  const inputBackgroundColor = useSelector(selectFieldBackgroundColor);
  const inputTextColor = useSelector(selectFieldTextColor);

  useEffect(() => {
    let showAlert = false;

    const inputBgChroma = chroma(inputBackgroundColor);
    const inputBgAlpha = inputBgChroma.alpha();

    if (formBackgroundImage && inputBgAlpha < ALPHA_THRESHOLD) {
      showAlert = true;
    } else if (!formBackgroundImage) {
      const textChroma = chroma(inputTextColor);
      const formBgChroma = chroma(formBackgroundColor);

      const effectiveBgChroma = calculateEffectiveBg(
        inputBgChroma,
        formBgChroma
      );

      const contrastRatio = chroma.contrast(textChroma, effectiveBgChroma);

      if (contrastRatio < CONTRAST_THRESHOLD) {
        showAlert = true;
      }
    }

    setAlert((currentAlertState) => {
      if (currentAlertState !== showAlert) {
        return showAlert;
      }
      return currentAlertState;
    });
  }, [
    inputTextColor,
    inputBackgroundColor,
    formBackgroundColor,
    formBackgroundImage,
    alert,
  ]);

  return alert;
}
